import React from 'react';

const ConditionalWrapper = ({
  ParentWrapper,
  parentProps,
  children,
  condition,
}) => {
  if (ParentWrapper && condition) {
    return <ParentWrapper {...parentProps}>{children}</ParentWrapper>;
  } else if (children) return children;
  else <div></div>;
};

export default ConditionalWrapper;
